import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withHashLocation,
  withInMemoryScrolling,
  withRouterConfig,
  withViewTransitions
} from '@angular/router';

import { DropdownModule, SidebarModule } from '@coreui/angular';
import { IconSetService } from '@coreui/icons-angular';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { MainService } from './services/main.service';
import { LocalStorageService } from './services/localStorage.service';
import { LoginService } from './services/login.service';
import { requestInterceptor } from './interceptor/request.interceptor';
import { progressInterceptor, provideNgProgressHttp } from 'ngx-progressbar/http';
import { provideNgxMask } from 'ngx-mask';

export const appConfig: ApplicationConfig = {
  providers: [
    LocalStorageService,
    MainService,
    LoginService,
    provideHttpClient(
      withInterceptors([requestInterceptor,progressInterceptor])
    ),
    provideRouter(routes,
      withRouterConfig({
        onSameUrlNavigation: 'reload'
      }),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled'
      }),
      withEnabledBlockingInitialNavigation(),
      withViewTransitions(),
      withHashLocation()
    ),
    importProvidersFrom(SidebarModule, DropdownModule),
    IconSetService,
    provideAnimations(),
    provideNgxMask(),
    provideNgProgressHttp({
      silentApis: ["entreprise/getPaymentStatus", "entreprise/getCommandeEcartePaymentStatus"]
    })
  ]
};
